import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  componentClassName: PropTypes.string.isRequired,
  item: PropTypes.shape({
    navigationItems: PropTypes.arrayOf(PropTypes.object),
    page: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
    text: PropTypes.string,
    link: PropTypes.shape({
      target: PropTypes.string,
      href: PropTypes.string,
    }),
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  toggleClassName: PropTypes.string.isRequired,
  closeMobileNav: PropTypes.func,
};

const defaultProps = {};

const StorageMartNavLinkToggle = ({
  componentClassName,
  item: {
    navigationItems, link, page, text,
  },
  onBlur,
  onFocus,
  onToggle,
  show,
  toggleClassName,
  closeMobileNav,
}) => {
  let Component;
  let componentProps = {
    onBlur,
    onFocus,
  };

  const toggleText = text || (page && page.title);
  const path = page && page.path;

  // Path could be '' if it's a link to the home page.
  const hasPath = path !== undefined && path !== null;
  const hasChildren = !!(navigationItems && navigationItems.length);

  if (!toggleText) {
    return null;
  }

  if (hasChildren) {
    Component = 'div';
    componentProps = {};
  }

  if (link) {
    const { target, href } = link;
    const linkName = href
      .replace(/^https?:\/\//, '')
      .replace(/[^a-zA-Z0-9]/g, '-')
      .toLowerCase();
    Component = 'a';
    componentProps = {
      ...componentProps,
      href,
      target: target || '_blank',
      rel: 'noopener noreferrer',
      onClick: closeMobileNav,
      [`data-${linkName}`]: '',
    };
  }

  if (hasPath) {
    Component = 'a';
    componentProps = {
      ...componentProps,
      href: path,
      onClick: closeMobileNav,
    };
  }

  if (!Component) {
    return null;
  }


  return (
    <span
      style={{
        display: 'flex',
        gap: '.25rem',
        flexGrow: '1',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexDirection: 'row',
      }}
    >
      <Component {...componentProps} className={componentClassName}>
        {toggleText}
      </Component>
      {hasChildren && (
        <button
          type="button"
          onBlur={onBlur}
          onFocus={onFocus}
          onClick={onToggle}
          className={toggleClassName}
          aria-haspopup={hasChildren}
          aria-expanded={hasChildren ? show : undefined}
        >
          <span className="sr-only">{toggleText}</span>
          <i className={`fa fa-fw fa-caret-${show ? 'up' : 'down'}`} aria-hidden="true" />
        </button>
      )}
    </span>
  );
};

StorageMartNavLinkToggle.propTypes = propTypes;
StorageMartNavLinkToggle.defaultProps = defaultProps;

export default StorageMartNavLinkToggle;
